import OriginModal from './Modal';

import {
  baseConfirm,
  withInfo,
  TemplateConfiglProps,
  withSuccess,
  withConfirm,
  withError,
  withWarning,
  ModalStaticFunctions,
} from './confirm';

export type ModalType = typeof OriginModal & ModalStaticFunctions;

const Modal = OriginModal as ModalType;

export type ModalFnProps = TemplateConfiglProps;

Modal.confirm = function infoFn(props: TemplateConfiglProps) {
  return baseConfirm(withConfirm(props));
};
Modal.info = function infoFn(props: TemplateConfiglProps) {
  return baseConfirm(withInfo(props));
};
Modal.success = function successFn(props: TemplateConfiglProps) {
  return baseConfirm(withSuccess(props));
};
Modal.error = function errorFn(props: TemplateConfiglProps) {
  return baseConfirm(withError(props));
};
Modal.warning = function warningFn(props: TemplateConfiglProps) {
  return baseConfirm(withWarning(props));
};

export default Modal;
